import { RegistrableApp } from './es/interfaces';
import { apiGetUserProjectListByGroup } from '@/api/user';
import i18n from '@/i18n';
import actions from '@/shared/actions';

const { domainName } = require('../../config');

const env = process.env.VUE_APP_ENV;
let localPorts: { [key: string]: number } = {
  _default: 9999
};

const localDefines = require(`../../config/${env === 'development' ? 'local.' : ''}defines`);
localPorts = localDefines.localPorts;

/**
 * 获取子应用入口
 * @param pathName 子应用独立运行时对应的路径，需和子应用中 nginx 配置保持一致
 */
const getEntry = (pathName: string): string => {
  let childAppEntry = '';
  if (env === 'development') {
    // 必须启动相应子应用
    childAppEntry = `//localhost:${localPorts[pathName] || localPorts['_default']}`;
  } else if (domainName[env]) {
    childAppEntry = `//${domainName[env]}/${pathName}/`;
  }
  return childAppEntry;
};

/**
 * 生成子应用配置
 * @param subAppName 子应用 vue.config.js 中的 configureWebpack.output.library 值，不可重复
 */
const genChildApp = (subAppName: string, subAppProjectName: string): RegistrableApp => {
  return {
    name: subAppName,
    entry: getEntry(subAppName),
    container: '#frame',
    activeRule: `/main-${subAppName}`,
    props: {
      projectName: i18n.global.t(`apps.${subAppName}`) || subAppProjectName
    }
  };
};

async function getApps() {
  const apps: RegistrableApp[] = [];
  try {
    const { data } = await apiGetUserProjectListByGroup();
    actions.setGlobalState({ projects: data });
    // 添加子应用
    data.forEach((item: Project.IProjectItem) => {
      item.data.forEach((subItem: Project.ISubProject) => {
        apps.push(genChildApp(subItem.projectTag, subItem.projectName));
      });
    });
  } catch (error) {
    console.error(error);
  }
  return apps;
}

export default getApps;
